import _ from '@lodash';
import { amber, blue, blueGrey, green, red } from '@material-ui/core/colors';
import mock from '../mock';

const streamingDB = {
	categories: [
		{
			id: 0,
			value: 'office_004',
			label: 'Civil Project',
			project: 'Head Office',
			color: blue[500]
		},
		{
			id: 1,
			value: 'office_002',
			label: 'Scai',
			project: 'Head Office',
			color: amber[500]
		},
		{
			id: 2,
			value: 'office_003',
			label: 'SAMURAI',
			project: 'Head Office',
			color: blueGrey[500]
		},
		{
			id: 3,
			value: 'samurai-team-001',
			label: 'samurai-team-001',
			project: 'Head Office',
			color: green[500]
		},
		{
			id: 4,
			value: '001',
			label: 'Project 1',
			project: 'Tokyo',
			color: red[500]
		}
	],
	cameras: [
		{
			id: '1',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'samurai-team-001',
			uuid: '1542e43dfwwe6jirf226',
			name: 'ASH_RTSP_1',
			projectuuid: 'puuid001'
		},
		{
			id: '2',
			url: 'https://test-videos.co.uk/vids/jellyfish/mp4/h264/1080/Jellyfish_1080_10s_1MB.mp4',
			category: 'samurai-team-001',
			uuid: '1542e43dfwwe6jirf224',
			name: 'chanelu',
			projectuuid: 'puuid001'
		},
		{
			id: '3',
			url: 'http://techslides.com/demos/sample-videos/small.mp4',
			category: '001',
			uuid: '1542e43dfwwe6jirf226',
			name: 'pixel3a',
			projectuuid: 'puuid002'
		},
		{
			id: '4',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: '001',
			uuid: '1542e43dfwwe6jirfl26',
			name: 'ADLINK-NEON-TEST1',
			projectuuid: 'puuid002'
		},
		{
			id: '4',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: '001',
			uuid: '1542e43dfwwe6jirf226',
			name: 'aesthdev',
			projectuuid: 'puuid002'
		},
		{
			id: '5',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_002',
			uuid: '1542e43dfwwe6jirf226',
			name: 'stream_tx2_ps'
		},
		{
			id: '6',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_002',
			uuid: '1542e43dfwwe6jirf226',
			name: 'stream_tx2_ps',
			projectuuid: 'puuid003'
		},
		{
			id: '7',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_002',
			uuid: '1542e43dfwwe6jirf226',
			name: 'KANDA-1',
			projectuuid: 'puuid003'
		},
		{
			id: '7',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_002',
			uuid: '1542e43dfwwe6jirf226',
			name: 'KANDA-2',
			projectuuid: 'puuid003'
		},
		{
			id: '8',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_003',
			uuid: '1542e43dfwwe6jirf226',
			name: 'KANDA-3',
			projectuuid: 'puuid004'
		},
		{
			id: '9',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_003',
			uuid: '1542e43dfwwe6jirf226',
			name: 'KANDA-4',
			projectuuid: 'puuid004'
		},
		{
			id: '10',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_003',
			uuid: '1542e43dfwwe6jirf226',
			name: 'KANDA-5',
			projectuuid: 'puuid004'
		},
		{
			id: '11',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_003',
			uuid: '1542e43dfaae6jirf226',
			name: 'KANDA-6',
			projectuuid: 'puuid004'
		},
		{
			id: '12',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'KANDA-7'
		},
		{
			id: '13',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'ADLINK-NEON-0',
			projectuuid: 'puuid005'
		},
		{
			id: '14',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'ADLINK-NEON-1',
			projectuuid: 'puuid005'
		},
		{
			id: '15',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'ADLINK-NEON-2',
			projectuuid: 'puuid005'
		},
		{
			id: '16',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'ADLINK-NEON-3',
			projectuuid: 'puuid005'
		},
		{
			id: '17',
			url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
			category: 'office_004',
			uuid: '1542e43dfaae6ebf226',
			name: 'ADLINK-NEON-4',
			projectuuid: 'puuid005'
		},
	]
};

mock.onGet('/api/projects/get').reply(() => {
	return [200, streamingDB.categories];
});

mock.onGet('/api/streaming/get').reply(() => {
	return [200, streamingDB.cameras.map(_course => _.omit(_course, ['steps']))];
});

mock.onGet('/api/academy-app/course').reply(request => {
	const { courseId } = request.params;
	const response = _.find(streamingDB.courses, { id: courseId });
	return [200, response];
});

mock.onPost('/api/academy-app/course/save').reply(request => {
	const data = JSON.parse(request.data);
	let course = null;

	streamingDB.courses = streamingDB.courses.map(_course => {
		if (_course.id === data.id) {
			course = data;
			return course;
		}
		return _course;
	});

	if (!course) {
		course = data;
		streamingDB.courses = [...streamingDB.courses, course];
	}

	return [200, course];
});

mock.onPost('/api/academy-app/course/update').reply(request => {
	const data = JSON.parse(request.data);
	streamingDB.courses = streamingDB.courses.map(_course => {
		if (_course.id === data.id) {
			return _.merge(_course, data);
		}
		return _course;
	});

	return [200, data];
});
